/**
 * The media query for the dark color scheme
 *
 * @type {string}
 */
const prefersDarkQuery = '(prefers-color-scheme: dark)';

/**
 * Get the preferred color scheme from the browser
 *
 * @returns {string} 'light' or 'dark'
 */
export const getPreferredColorScheme = () => {
  if (typeof globalThis === 'undefined' || typeof globalThis.matchMedia !== 'function') {
    return 'light';
  }

  return globalThis.matchMedia(prefersDarkQuery).matches ? 'dark' : 'light';
};

export const prefersDarkMediaQuery = prefersDarkQuery;
